const show = (el) => {
  el.removeAttribute("aria-hidden");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = null;
  });
};

const hide = (el) => {
  el.setAttribute("aria-hidden", "true");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = -1;
  });
};

class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
    this.sliderEl = this.querySelector("[data-slider]");
    this.slides = this.querySelectorAll("[data-slide]");
    this.prevButton = this.querySelector(".swiper-button-prev");
    this.nextButton = this.querySelector(".swiper-button-next");
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        spaceBetween: 16,
        speed: 250,
        loop: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        breakpoints: {
          1024: {
            spaceBetween: 24,
          },
        },
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        on: {
          slideChangeTransitionStart: () => {
            this.swiper.slides.forEach((slide) => {
              hide(slide);
            });
          },
          slideChangeTransitionEnd: () => {
            window.requestAnimationFrame(() => {
              this.swiper.slides.forEach((slide) => {
                slide.classList.contains("swiper-slide-visible")
                  ? show(slide)
                  : hide(slide);
              });
            });
          },
        },
      };

      this.swiper = new Swiper(this.sliderEl, swiperParams);

      this.swiper.slides.forEach((slide) => {
        slide.classList.contains("swiper-slide-visible")
          ? show(slide)
          : hide(slide);
      });
    });
  }
}

if (!customElements.get("collection-carousel")) {
  customElements.define("collection-carousel", CollectionCarousel);
}
